import React, { ReactNode, useEffect, useState } from 'react';
import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material';

import CommonButton from './CommonButton';
import { useWeb3 } from '@/hooks/use-web3';

import { ShortenAddr } from '@/lib/Shorten';
import ConnectInfo from '@/component/ConnectWallet/ConnectInfo';
import SymbolSvg from '@/assets/assetfi/Symbol';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

interface CommonTopPropsType {
  title: string;
  subtitle: string;
  children?: ReactNode;
  avatar?: boolean;
  sx?: SxProps<Theme>;
}

const CommonTop = ({ title, subtitle, avatar, children, sx }: CommonTopPropsType) => {
  // use
  const theme = useTheme();
  const { address: addr, clearWeb3Auth } = useWeb3();

  const { isConnected, connect } = useWeb3AuthConnect();
  // state
  const [address, setAddress] = useState('');
  const [isConnect, setIsConnect] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (address) {
      return;
    }
    (async () => {
      if (isConnected) {
        setAddress(addr);
        setIsConnect(true);
      }
    })();
    return () => {};
  }, [isConnected, addr]);

  // method
  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   address ? setAnchorEl(event.currentTarget) : setWallet(true);
  // };
  const handleClose = () => {
    setAnchorEl(null);
    if (address) {
      setIsConnect(true);
    } else {
      setIsConnect(false);
    }
  };

  const handleConnect = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (address) {
      setAnchorEl(event.currentTarget);
      return;
    }
    clearWeb3Auth();
    await connect();
    setIsConnect(true);
    console.log(`handleConnect`);
  };
  return (
    <Box
      sx={{
        background: theme.background.default,
        ...sx,
      }}
    >
      <Box
        sx={{
          padding: { xs: '16px 24px', md: '20px 24px' },
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '1680px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          {avatar && <SymbolSvg width={48} height={48} />}
          <Box>
            <Typography color={theme.greyscale.darkgrey2} variant={'h2'}>
              {title}
            </Typography>
            <Typography color={theme.greyscale.grey3} variant={'body1'}>
              {subtitle}
            </Typography>
          </Box>
        </Box>

        <CommonButton
          bgColor={isConnect ? '#ffffff' : theme.brand.primary}
          color={isConnect ? theme.background.blue : '#ffffff'}
          text={isConnect ? ShortenAddr(address) : 'Connect Wallet'}
          handleClick={handleConnect}
          variant={isConnect ? 'h6' : 'subtitle2'}
          sx={{
            display: {
              xs: 'none',
              md: 'block',
            },
            height: '36px',
            borderRadius: '10px',
            padding: '6px 20px 6px 20px',
            boxShadow: isConnect ? '0px 0px 4px 0px #00000026' : 'none',
          }}
          icon={isConnect ? 'symbol' : null}
        />
      </Box>

      {children}

      <ConnectInfo open={open} handleClose={handleClose} anchorEl={anchorEl} />
      {/* <WalletMenu open={open} anchorEl={anchorEl} handleClose={handleClose} /> */}
    </Box>
  );
};

export default CommonTop;
